export default __webpack_public_path__ + "static/media/txt3_pc.e56baf57.png";